$(function(){
  $(document).on('keyup','.u_input_search',function(){
    let searchTerm = $(this).val();
    console.log('keyup',searchTerm.length)
    if(searchTerm.length != 0){
      console.log('if condition',searchTerm.length)
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=query,product&section_id=predictive-search`)
    .then((response)=>{
      if(response.status == '200'){
      return response.text()        
      }

    })
    .then((resolve)=>{ 
      $('.u_search_body').hide()
      $('.u_search_body_append').show().html(resolve)
          var swiper = new Swiper(".z_feature_collection", {
       slidesPerView: "auto",
      spaceBetween: 10,
      freeMode: true      
    });
        var swiper = new Swiper(".dm_main_collection_product .mySwiper", {
    slidesPerView: 4.8,
    spaceBetween: 5,
    freeMode: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
    }).
      catch((err)=>{
       console.log('error',err) 
      })
}
  else{
          console.log('if condition',searchTerm.length)
          $('.u_search_body').show()
      $('.u_search_body_append').empty()
  }
})
})